var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg41(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M46.83,10.84H45.1c-0.31,0-0.56-0.25-0.56-0.56V9.6c0-0.31-0.25-0.56-0.56-0.56h-7.37 c-0.31,0-0.56,0.25-0.56,0.56v0.69c0,0.31-0.25,0.56-0.56,0.56H12.64c-0.31,0-0.56-0.25-0.56-0.56V9.6c0-0.31-0.25-0.56-0.56-0.56 H4.15c-0.31,0-0.56,0.25-0.56,0.56v0.69c0,0.31-0.25,0.56-0.56,0.56H1.3c-0.31,0-0.56,0.25-0.56,0.56v27.61 c0,0.31,0.25,0.56,0.56,0.56h45.53c0.31,0,0.56-0.25,0.56-0.56V11.4C47.39,11.1,47.14,10.84,46.83,10.84z M12.07,18.21 c0,0.31-0.25,0.56-0.56,0.56H9.23c-0.31,0-0.56,0.25-0.56,0.56v2.27c0,0.31-0.25,0.56-0.56,0.56H7.55c-0.31,0-0.56-0.25-0.56-0.56 v-2.27c0-0.31-0.25-0.56-0.56-0.56H4.16c-0.31,0-0.56-0.25-0.56-0.56v-0.56c0-0.31,0.25-0.56,0.56-0.56h2.27 c0.31,0,0.56-0.25,0.56-0.56v-2.27c0-0.31,0.25-0.56,0.56-0.56h0.56c0.31,0,0.56,0.25,0.56,0.56v2.27c0,0.31,0.25,0.56,0.56,0.56 h2.27c0.31,0,0.56,0.25,0.56,0.56V18.21z M44.53,18.21c0,0.31-0.25,0.56-0.56,0.56h-7.35c-0.31,0-0.56-0.25-0.56-0.56v-0.56 c0-0.31,0.25-0.56,0.56-0.56h7.35c0.31,0,0.56,0.25,0.56,0.56V18.21z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg41);
export default __webpack_public_path__ + "static/media/41.8714378849d42f7a165068f6de9a462c.svg";
export { ForwardRef as ReactComponent };